import React from 'react';
import { Icon } from 'antd';

import Home from '../views/Home'
import Case from '../views/Cases'
import CaseUploadCT from '../views/Cases/caseUploadCT'
import CaseUploadCTAlign from '../views/Cases/caseUploadCTAlign'
import CaseUploadCTv2 from '../views/Cases/caseUploadCTv2'
import CaseUploadCTv2Auto from '../views/Cases/caseUploadCTv2Auto'
import CaseUploadPlanStandart from '../views/Cases/caseUploadPlanStandart'
import CaseUploadPlanRoots from '../views/Cases/caseUploadPlanRoots'
import CaseUploadPlanDeepCT from '../views/Cases/caseUploadPlanDeepCT'
import CaseUploadPlanStandartOrthostudio from '../views/Cases/caseUploadPlanStandartOrthostudio'
import CaseUploadPlanStandart3shape1c from '../views/Cases/caseUploadPlanStandart3shape1c'
import CaseUploadPlanStandart3shapeColor from '../views/Cases/caseUploadPlanStandart3shapeColor'
import CaseUploadPlanStandartArchform1c from '../views/Cases/caseUploadPlanStandartArchform1c'
import CaseUploadPlanStandartOnyxceph from '../views/Cases/caseUploadPlanStandartOnyxceph'
import CaseUploadPlanStandartSureSmileSOU from '../views/Cases/caseUploadPlanStandartSureSmileSOU'
import CaseUploadPlanStandartOrthoStudioV5 from '../views/Cases/caseUploadPlanStandartOrthoStudioV5'
import CaseUploadPlanStandartNemo from '../views/Cases/caseUploadPlanStandartNemo'
import CaseUploadTeethAlignmentModelling from '../views/Cases/caseUploadTeethAlignmentModelling'

import PlanUpdateForm from '../views/Cases/planUpdateForm'

export const Routes = [
  {
    'path':'/home',
    'component': Case,
    'exactly': true,
    'menuTitle': <span><Icon type="home"/>Home</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/ct',
    'component': CaseUploadCT,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/ct-align',
    'component': CaseUploadCTAlign,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/ct-v2',
    'component': CaseUploadCTv2,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/ct-v2-auto',
    'component': CaseUploadCTv2Auto,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standart',
    'component': CaseUploadPlanStandart,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-roots',
    'component': CaseUploadPlanRoots,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-deep-ct',
    'component': CaseUploadPlanDeepCT,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-orthostudio',
    'component': CaseUploadPlanStandartOrthostudio,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-3shape-1c',
    'component': CaseUploadPlanStandart3shape1c,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-3shape-color',
    'component': CaseUploadPlanStandart3shapeColor,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-archform-1c',
    'component': CaseUploadPlanStandartArchform1c,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-onyxceph',
    'component': CaseUploadPlanStandartOnyxceph,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/plan-update-form/:uuid',
    'component': PlanUpdateForm,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-orthostudio-v5',
    'component': CaseUploadPlanStandartOrthoStudioV5,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-suresmile-sou',
    'component': CaseUploadPlanStandartSureSmileSOU,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/plan-standard-nemo',
    'component': CaseUploadPlanStandartNemo,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  },
  {
    'path':'/case/upload/teeth-alignment-modelling',
    'component': CaseUploadTeethAlignmentModelling,
    'exactly': true,
    'menuTitle': <span><Icon type="folder-add"/>Case</span>,
    'menuGroup': 'main'
  }
];


// WEBPACK FOOTER //
// ./src/routes/index.jsx